import React from 'react';
// project imports
import { Grid,Button,TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Stack, } from "@mui/material";
import { gridSpacing } from "../../store/constant";
import ManufacturerServices from '../../services/ManufacturerServices';
import { useEffect,useState } from 'react';
//Datatables
import DynamicDatatables from '../../datatables/DynamicDatatables';
import {manufacturerColumns} from '../../datatables/rowsColumn';
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useTranslation } from 'react-i18next';
import tableTheme from "../../ui-component/customTableUi";
import { ThemeProvider } from "@mui/material/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
import DownloadIcon from "@mui/icons-material/Download";
import ClearIcon from "@mui/icons-material/Clear";
import PrintIcon from "@mui/icons-material/Print";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const ManufacturerList = () => {
  const { t } = useTranslation();
 const [load, setLoad] = useState(false);

const [manufacturer, setManufacturer] = useState([]);

const [search, setSearch] = useState("");

const [openFilter, setOpenFilter] = useState(false);

const defaultFilters = {
  manufacturer_id: "",
  company_name: "",
  name: "",
  email: "",
  phone_no: "",
  address: "",
  state: "",
  manufacturer_type: "",
  status: "",
  gstnnumber: "",
  expirydate: "",
  expirydate_from: "",
  expirydate_to: "",
  created: "",
  created_from: "",
  created_to: "",
};

const [filters, setFilters] = useState(defaultFilters);
  // useEffect(()=>{
  //   const fetchManufacturerList = async () => {
  //     try {
  //       const response = await ManufacturerServices.findManufacturer();
  //       const apiData = response && response.data ? response.data : [];
  //       setManufacturer(Array.isArray(apiData) ? apiData : []);
  //       setLoad(true);
  //     } catch (error) {
  //       console.log("Error fetching manufacturers:", error);
  //       setManufacturer([]);
  //       setLoad(true);
  //     }
  //   };
  //   fetchManufacturerList();
  // }, [])
  //For actions refer AvailableForSale Component
  

  useEffect(() => {
  fetchManufacturerList(defaultFilters);
}, []);

const fetchManufacturerList = async (payload = defaultFilters) => {
  try {
    setLoad(false);

    const response = await ManufacturerServices.findManufacturer(payload);

    const apiData = response?.data || [];

    setManufacturer(Array.isArray(apiData) ? apiData : []);

    setLoad(true);
  } catch (error) {
    console.log(error);

    setManufacturer([]);

    setLoad(true);
  }
};

useEffect(() => {
  const timer = setTimeout(() => {
    fetchManufacturerList({
      ...filters,
      company_name: search,
    });
  }, 500);

  return () => clearTimeout(timer);
}, [search]);

const applyFilter = () => {
  fetchManufacturerList(filters);
  setOpenFilter(false);
};

const clearFilter = () => {
  setFilters(defaultFilters);

  setSearch("");

  fetchManufacturerList(defaultFilters);
};

const isFilterApplied = Object.values(filters).some(
  (value) => value !== ""
);

const downloadExcel = async () => {
  try {
    const payload = isFilterApplied
      ? filters
      : {
          ...defaultFilters,
          company_name: search,
        };

    const response = await ManufacturerServices.findManufacturer(payload);

    const data = response?.data || [];

    if (!Array.isArray(data) || data.length === 0) {
      alert("No data found");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Manufacturers");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, "Manufacturers.xlsx");
  } catch (err) {
    console.log(err);
  }
};

const printManufacturerList = async () => {
  try {
    const payload = isFilterApplied
      ? filters
      : {
          ...defaultFilters,
          company_name: search,
        };

    const response = await ManufacturerServices.findManufacturer(payload);

    const data = response?.data || [];

    if (!Array.isArray(data) || data.length === 0) {
      alert("No data found");
      return;
    }

    const html = `
      <html>
      <head>
        <title>Manufacturer List</title>
        <style>
          body{
            font-family: Arial, sans-serif;
            padding:20px;
          }

          h2{
            text-align:center;
            margin-bottom:20px;
          }

          table{
            width:100%;
            border-collapse:collapse;
          }

          th,td{
            border:1px solid #000;
            padding:8px;
            font-size:12px;
            text-align:left;
          }

          th{
            background:#f2f2f2;
          }
        </style>
      </head>

      <body>

        <h2>Manufacturer List</h2>

        <table>
          <thead>
            <tr>
              <th>Company Name</th>
              <th>Manufacturer Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Address</th>
              <th>State</th>
              <th>Manufacturer Type</th>
              <th>GST Number</th>
              <th>Status</th>
              <th>Expiry Date</th>
            </tr>
          </thead>

          <tbody>
            ${data
              .map(
                (item) => `
                  <tr>
                    <td>${item.company_name || ""}</td>
                    <td>${item.name || ""}</td>
                    <td>${item.email || ""}</td>
                    <td>${item.phone_no || ""}</td>
                    <td>${item.address || ""}</td>
                    <td>${item.state || ""}</td>
                    <td>${item.manufacturer_type || ""}</td>
                    <td>${item.gstnnumber || ""}</td>
                    <td>${item.status || ""}</td>
                    <td>${item.expirydate || ""}</td>
                  </tr>
                `
              )
              .join("")}
          </tbody>
        </table>

      </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.focus();
    printWindow.print();
    printWindow.close();
  } catch (err) {
    console.log(err);
  }
};

const handleFilterChange = (field, value) => {
  setFilters((prev) => ({
    ...prev,
    [field]: value,
  }));
};

  const actionColumn = [
    {
      name: "Action",
      label: "Action",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta) => {
          // Note: tableMeta.rowData contains raw values from API (timestamps, where present, are in GMT/UTC).
          return (
            <div className="cellAction" style={{ display: "flex" }}>
              <Link
                to={`/user/detail/manufacturer/${tableMeta.rowData[0]}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">
                  <VisibilityIcon />
                </div>
              </Link>
            </div>
          );
        },
      },
    },
  ];
  return (
  <>
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="space-between"
          sx={{ mb: 2 }}
        >
          <TextField
            size="small"
            placeholder="Search Company Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ width: 300 }}
          />

          <Stack direction="row" spacing={2}>
            <Button
  variant="outlined"
  startIcon={<FilterListIcon />}
  onClick={() => setOpenFilter((prev) => !prev)}
>
  Filter
</Button>

            <Button
              variant="outlined"
              color="success"
              startIcon={<DownloadIcon />}
              onClick={downloadExcel}
            >
              Download
            </Button>
<Button
  variant="outlined"
  color="primary"
  startIcon={<PrintIcon />}
  onClick={printManufacturerList}
>
  Print
</Button>
            <Button
              variant="outlined"
              color="error"
              startIcon={<ClearIcon />}
              onClick={clearFilter}
            >
              Clear
            </Button>
          </Stack>
        </Stack>
{openFilter && (
  <Grid
    container
    spacing={2}
    sx={{
      mb: 2,
      mt:1,
      p: 2,
      border: "1px solid #ddd",
      borderRadius: 2,
      backgroundColor: "#fafafa",
    }}
  >
    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Company Name"
        value={filters.company_name}
        onChange={(e) =>
          handleFilterChange("company_name", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Manufacturer Name"
        value={filters.name}
        onChange={(e) =>
          handleFilterChange("name", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Email"
        value={filters.email}
        onChange={(e) =>
          handleFilterChange("email", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Phone"
        value={filters.phone_no}
        onChange={(e) =>
          handleFilterChange("phone_no", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Address"
        value={filters.address}
        onChange={(e) =>
          handleFilterChange("address", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="State"
        value={filters.state}
        onChange={(e) =>
          handleFilterChange("state", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Manufacturer Type"
        value={filters.manufacturer_type}
        onChange={(e) =>
          handleFilterChange("manufacturer_type", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        select
        fullWidth
        label="Status"
        value={filters.status}
        onChange={(e) =>
          handleFilterChange("status", e.target.value)
        }
      >
        <MenuItem value="">All</MenuItem>
        <MenuItem value="true">Active</MenuItem>
        <MenuItem value="false">Inactive</MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="GST Number"
        value={filters.gstnnumber}
        onChange={(e) =>
          handleFilterChange("gstnnumber", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        type="date"
        fullWidth
        label="Expiry From"
        InputLabelProps={{ shrink: true }}
        value={filters.expirydate_from}
        onChange={(e) =>
          handleFilterChange("expirydate_from", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        type="date"
        fullWidth
        label="Expiry To"
        InputLabelProps={{ shrink: true }}
        value={filters.expirydate_to}
        onChange={(e) =>
          handleFilterChange("expirydate_to", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        type="date"
        fullWidth
        label="Created From"
        InputLabelProps={{ shrink: true }}
        value={filters.created_from}
        onChange={(e) =>
          handleFilterChange("created_from", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        type="date"
        fullWidth
        label="Created To"
        InputLabelProps={{ shrink: true }}
        value={filters.created_to}
        onChange={(e) =>
          handleFilterChange("created_to", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12}>
      <Stack
        direction="row"
        justifyContent="flex-end"
        spacing={2}
      >
        <Button
          variant="outlined"
          onClick={clearFilter}
        >
          Clear
        </Button>

        <Button
          variant="contained"
          onClick={applyFilter}
        >
          Apply Filter
        </Button>
      </Stack>
    </Grid>
  </Grid>
)}
        <ThemeProvider theme={tableTheme}>
          {load && (
            <DynamicDatatables
              tableTitle={t("manufacturer.listTitle")}
              rows={manufacturer}
              columns={manufacturerColumns.concat(actionColumn)}
              helperText="Timestamps are in GMT/UTC."
              options={{
    search: false,
    filter: false,
    print: false,
    download: false,
    viewColumns: false,
    selectableRows: "none",
  }}
            />
          )}
        </ThemeProvider>
      </Grid>
    </Grid>

  </>
);
}

export default ManufacturerList;

